import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Junction from "./Junction";
import Path from "./Path";
import Labels from "./Labels";
import { junctionlist } from "./lists/junctionList";
import { pathlist } from "./lists/pathList";
import { junctionGroups, pathGroups } from "./lists/groupLists";
import styleConstants from "../../../../styleConstants";

const useStyles = makeStyles(theme => ({
  svgContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  pathway: {
    fill: styleConstants.colors.gray1,
    stroke: styleConstants.colors.gray3,
    strokeWidth: 1,
    strokeMiterlimit: 10
  }
}));

const SectorGraphic = props => {
  const classes = useStyles();

  const [currentGroup, setCurrentGroup] = useState("node8");

  const setItemGroups = (itemList, groupList) => {
    let arr = [];
    itemList.forEach(item => {
      if (!item.groups) {
        groupList.forEach(groupItem => {
          if (groupItem.id === item.id) {
            item.groups = groupItem.groups;
          }
        });
      }
      arr.push(item);
    });
    return arr;
  };

  const paths = setItemGroups(pathlist, pathGroups).map(obj => (
    <Path key={obj.id} {...obj} current={currentGroup} />
  ));

  const junctions = setItemGroups(junctionlist, junctionGroups).map(obj => (
    <Junction
      key={obj.id}
      {...obj}
      updateCurrent={() => {
        setCurrentGroup(obj.id);
      }}
      removeCurrent={() => setCurrentGroup(undefined)}
      current={currentGroup}
    />
  ));

  return (
    <div className={classes.svgContainer}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 960 500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={classes.pathway}
          d="M812.9 284.1h76.2c5.9 0 10.7-4.8 10.7-10.7 0-5.9-4.8-10.7-10.7-10.7h-76.2c-31.5 0-62.6-8.9-95.1-19.5-3.9 3.9-7.8 7.8-11.7 11.6l-5.2 5.2c14 4.7 28.2 9.3 42.4 13.2-17 4.6-33.9 10.1-50.5 15.5-11.5 3.8-22.9 7.5-34.1 10.8 14.3-11.9 28.3-25.7 42.2-39.5l5.2-5.2c3.9-3.9 7.8-7.8 11.7-11.6 32.2-31.9 65-61.6 95.1-61.6h76.2c5.9 0 10.7-4.8 10.7-10.7s-4.8-10.7-10.7-10.7h-76.2c-40 0-79.5 13.5-117.7 26.5S620.9 212 584.4 212H51c-5.9 0-10.7 4.8-10.7 10.7 0 5.9 4.8 10.7 10.7 10.7h173.5c-11.4 9.9-20.8 21.9-29.7 33.2-19.5 24.9-36.4 46.4-67.8 46.4H51c-5.9 0-10.7 4.8-10.7 10.7 0 5.9 4.8 10.7 10.7 10.7H453.2c-11.1 10-20 22.1-28.4 33.6-18.5 25.4-34.5 47.3-69 47.3H51c-5.9 0-10.7 4.8-10.7 10.7 0 5.9 4.8 10.7 10.7 10.7h533.3c34.6 0 70.5 11.7 108.5 24.1 39.1 12.8 79.6 25.9 120 25.9H889c5.9 0 10.7-4.8 10.7-10.7 0-5.9-4.8-10.7-10.7-10.7h-76.2c-29.8 0-62.2-29-94.2-60.5-4.2-4.1-8.4-8.3-12.6-12.5-1.4-1.4-2.9-2.9-4.4-4.3-14.2-14.1-28.5-28.2-43.1-40.3 11.8 3.6 23.8 7.6 36 11.6 16.2 5.4 32.7 10.9 49.3 15.5-14.2 3.9-28.3 8.5-42.2 13.2 1.5 1.4 2.9 2.9 4.4 4.3 4.2 4.2 8.4 8.4 12.6 12.5 30.8-10.2 60.4-18.7 90.1-19.4H889c5.9 0 10.7-4.8 10.7-10.7v-.1-.1c0-5.9-4.8-10.7-10.7-10.7h-80.3c-35.4-.9-72-13.1-107.4-25-16.1-5.4-32.4-10.9-48.9-15.4 15.7-4.3 31.4-9.4 46.9-14.5 37.8-12.1 76.6-24.8 113.6-24.8zm-360.7-50.7c-7.7 6.7-14.5 14.4-20.7 22.3 2.9 3.6 5.8 7.3 8.6 10.8 1.7 2.2 3.3 4.3 5 6.4 16.9-21.8 33.3-39.5 63.1-39.5h76.2c31.1 0 61.9 8.7 93.9 19.2 4.3-4.2 8.6-8.5 12.8-12.8l4.1-4.1c-13.9-4.6-28-9.2-42.2-13 16.6-4.6 32.9-10.2 49.1-15.7 12.3-4.2 24.5-8.3 36.5-12-14.7 12.2-29.1 26.5-43.4 40.7l-4.1 4.1c-4.3 4.3-8.5 8.6-12.8 12.8-31.9 31.5-64.3 60.4-93.9 60.4h-76.2c-29 0-45.6-18-63.1-40.1-1.7-2.1-3.3-4.2-5-6.4-2.8-3.6-5.6-7.2-8.6-10.8-6.4-7.8-13.2-15.5-20.9-22.3h41.6zM410.8 313c7.8-6.9 14.6-14.7 20.9-22.7-2.9-3.6-5.7-7.1-8.4-10.6-1.7-2.2-3.5-4.4-5.2-6.6-17 22-33 40-62.3 40H181.9c11.4-9.9 20.8-21.9 29.7-33.2 19.5-24.9 36.4-46.4 67.8-46.4h76.4c28.6 0 45 17.7 62.3 39.6 1.7 2.2 3.4 4.4 5.2 6.6 2.7 3.5 5.5 7.1 8.4 10.6 6.5 8 13.4 15.9 21.3 22.7h-42.2zm268.4 82.5c4 3.9 8 7.9 11.9 11.9l5 5c14.3 14.3 28.8 28.4 43.5 40.5-13.4-3.8-26.8-8.2-40.1-12.5-15.5-5-31.1-10.1-46.8-14.4 14.6-4 29.1-8.8 43.4-13.6l-5-5c-4-4-7.9-8-11.9-11.9-32.5 10.7-63.6 19.7-94.8 19.7H412.5c11.7-10.2 20.9-22.8 29.5-34.7 18.1-24.7 33.6-46 66.2-46.2h76.2c29.9 0 62.6 29.4 94.8 61.2z"
        />
        {paths}
        {junctions}
        <Labels current={currentGroup} />
      </svg>
    </div>
  );
};

export default SectorGraphic;
